// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tracking-icon {
    padding: 4px;
    text-align: left;
    vertical-align: middle;
    background-color: #4c4a4a42;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
    border-radius: 8px 8px 0px 0px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    margin: 4px; /* Space between cells */
  }
  /* Container */
.container {
  display: flex;
  padding-top: 20px;
}

/* First div */
.first-div {
  width: 30%;
  margin-right: 20px;
  overflow-y: scroll;
  border: 1px solid #ccc;
  padding: 10px;
}

.first-div-large {
  height: 600px;
}

.first-div-small {
  height: 400px;
}

/* Form grid container */
.form-grid-container {
  padding-top: 10px !important;
  margin-left: 0;
}

/* Grid item */
.grid-item {
  padding-top: 10px !important;
  width: 98% !important;
  padding-left: 0px !important;
}

/* Button styles */
.submit-button {
  height: 51px;
  min-width: 56px;
  border: 1px solid #c6c7c9;
  background-color: white;
  box-shadow: none;
  border-radius: 0px 12px 12px 0px;
  margin-left: -12px;
}

.submit-button-icon {
  color: #c6c7c9;
  height: 1.5rem;
  width: 1.5rem;
}

/* Table container */
.table-container {
  margin-top: 16px;
  border-radius: 12px 12px 0px 0px;
}

/* Tracking icon table cell */
.tracking-icon {
  cursor: pointer;
}

.tracking-icon img {
  width: 16px;
  margin-right: 4px;
  float: left;
}

.tracking-icon .icon-text {
  color: black;
  font-size: 12px;
  font-weight: bold;
  display: block;
  float: left;
}

/* Table row */
.table-row {
  border-bottom: none;
}

.table-cell {
  padding-bottom: 5px;
  border: 1px solid #ddd;
  background-color: white;
  cursor: pointer;
}

.table-cell-selected {
  background-color: rgb(167, 169, 171);
}

.table-cell img {
  width: 20px;
  margin-right: 4px;
  margin-bottom: 4px;
  float: left;
}

.table-cell span {
  display: block;
  float: left;
}

/* Table container */
.skytron-table-container {
  margin-top: 20px;
  max-height: 500px; /* Set max height for vertical scrolling */
  max-width: 100%; /* Set max width for horizontal scrolling */
  overflow-x: auto; /* Enable horizontal scrolling */
  overflow-y: auto; /* Enable vertical scrolling */
  border-radius: 8px; /* Round corners */
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
}

/* Table */
.skytron-table {
  border-collapse: collapse;
}

/* Table header cell */
.skytron-table-header-cell {
  font-weight: bold;
  padding: 10px;
  text-transform: capitalize; /* Capitalize header labels */
  white-space: nowrap; /* Ensure one-liner headers */
  border: 1px solid #ddd;
  background-color: #eef2f6;
  font-size: 12px;
  color: #090a0a;
}

/* Table row */
.skytron-table-row {
  background-color: white;
}

.skytron-table-row:nth-child(even) {
  background-color: #f5f5f5; /* Zebra striping for rows */
}

/* Table cell */
.skytron-table-cell {
  padding: 8px 12px; /* Add consistent padding to cells */
  border: 1px solid #ddd; /* Add border to table cells */
}

/* No data available cell */
.skytron-no-data-cell {
  text-align: center;
  padding: 20px;
  color: #888; /* Light gray text for no data message */
  border: 1px solid #ddd; /* Add border for no data message */
}
`, "",{"version":3,"sources":["webpack://./src/Pages/location based/tabstyle.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,eAAe;IACf,6BAA6B;IAC7B,8BAA8B;IAC9B,wCAAwC;IACxC,WAAW,EAAE,wBAAwB;EACvC;EACA,cAAc;AAChB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,iBAAiB,EAAE,0CAA0C;EAC7D,eAAe,EAAE,2CAA2C;EAC5D,gBAAgB,EAAE,gCAAgC;EAClD,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB,EAAE,kBAAkB;EACtC,2CAA2C,EAAE,4BAA4B;AAC3E;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,aAAa;EACb,0BAA0B,EAAE,6BAA6B;EACzD,mBAAmB,EAAE,6BAA6B;EAClD,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;AACzD;;AAEA,eAAe;AACf;EACE,iBAAiB,EAAE,oCAAoC;EACvD,sBAAsB,EAAE,8BAA8B;AACxD;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW,EAAE,wCAAwC;EACrD,sBAAsB,EAAE,mCAAmC;AAC7D","sourcesContent":[".tracking-icon {\n    padding: 4px;\n    text-align: left;\n    vertical-align: middle;\n    background-color: #4c4a4a42;\n    cursor: pointer;\n    border-bottom: 1px solid #ddd;\n    border-radius: 8px 8px 0px 0px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    margin: 4px; /* Space between cells */\n  }\n  /* Container */\n.container {\n  display: flex;\n  padding-top: 20px;\n}\n\n/* First div */\n.first-div {\n  width: 30%;\n  margin-right: 20px;\n  overflow-y: scroll;\n  border: 1px solid #ccc;\n  padding: 10px;\n}\n\n.first-div-large {\n  height: 600px;\n}\n\n.first-div-small {\n  height: 400px;\n}\n\n/* Form grid container */\n.form-grid-container {\n  padding-top: 10px !important;\n  margin-left: 0;\n}\n\n/* Grid item */\n.grid-item {\n  padding-top: 10px !important;\n  width: 98% !important;\n  padding-left: 0px !important;\n}\n\n/* Button styles */\n.submit-button {\n  height: 51px;\n  min-width: 56px;\n  border: 1px solid #c6c7c9;\n  background-color: white;\n  box-shadow: none;\n  border-radius: 0px 12px 12px 0px;\n  margin-left: -12px;\n}\n\n.submit-button-icon {\n  color: #c6c7c9;\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n/* Table container */\n.table-container {\n  margin-top: 16px;\n  border-radius: 12px 12px 0px 0px;\n}\n\n/* Tracking icon table cell */\n.tracking-icon {\n  cursor: pointer;\n}\n\n.tracking-icon img {\n  width: 16px;\n  margin-right: 4px;\n  float: left;\n}\n\n.tracking-icon .icon-text {\n  color: black;\n  font-size: 12px;\n  font-weight: bold;\n  display: block;\n  float: left;\n}\n\n/* Table row */\n.table-row {\n  border-bottom: none;\n}\n\n.table-cell {\n  padding-bottom: 5px;\n  border: 1px solid #ddd;\n  background-color: white;\n  cursor: pointer;\n}\n\n.table-cell-selected {\n  background-color: rgb(167, 169, 171);\n}\n\n.table-cell img {\n  width: 20px;\n  margin-right: 4px;\n  margin-bottom: 4px;\n  float: left;\n}\n\n.table-cell span {\n  display: block;\n  float: left;\n}\n\n/* Table container */\n.skytron-table-container {\n  margin-top: 20px;\n  max-height: 500px; /* Set max height for vertical scrolling */\n  max-width: 100%; /* Set max width for horizontal scrolling */\n  overflow-x: auto; /* Enable horizontal scrolling */\n  overflow-y: auto; /* Enable vertical scrolling */\n  border-radius: 8px; /* Round corners */\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n}\n\n/* Table */\n.skytron-table {\n  border-collapse: collapse;\n}\n\n/* Table header cell */\n.skytron-table-header-cell {\n  font-weight: bold;\n  padding: 10px;\n  text-transform: capitalize; /* Capitalize header labels */\n  white-space: nowrap; /* Ensure one-liner headers */\n  border: 1px solid #ddd;\n  background-color: #eef2f6;\n  font-size: 12px;\n  color: #090a0a;\n}\n\n/* Table row */\n.skytron-table-row {\n  background-color: white;\n}\n\n.skytron-table-row:nth-child(even) {\n  background-color: #f5f5f5; /* Zebra striping for rows */\n}\n\n/* Table cell */\n.skytron-table-cell {\n  padding: 8px 12px; /* Add consistent padding to cells */\n  border: 1px solid #ddd; /* Add border to table cells */\n}\n\n/* No data available cell */\n.skytron-no-data-cell {\n  text-align: center;\n  padding: 20px;\n  color: #888; /* Light gray text for no data message */\n  border: 1px solid #ddd; /* Add border for no data message */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
